import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PublicLayout from '../../layouts/Public';

const PublicRoute = ({ component: Component, auth, firstTimeIn, ...rest }) => {

  const currentUser = JSON.parse(localStorage.getItem('currentUser'));

  return (
    <Route
      {...rest}
      render={(props) =>
        auth && (!firstTimeIn || currentUser?.email.endsWith('@hp.com')) ? (
          <Redirect to="/" />
        ) : (
            Component.name == "UserInfoForm" && !auth ? (
              <Redirect to="/login" />
            ) : (
                Component.name == "Login" && auth ? (
                  <Redirect to="/userinfo" />
                ) : (
                    <PublicLayout>
                      <Component {...props} />
                    </PublicLayout>
                  )                
              )
          )
      }
/>
  );
};

export default PublicRoute;
